import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/views/Auth";
import CustomContainer from "../../components/CustomComponents/CustomContainer/CustomContainer";
import CustomPaper from "../../components/CustomComponents/CustomPaper/CustomPaper";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import Logo from "../../assets/images/Logo.png";
import Login from "../../components/Login/Login";
import Logout from "../../components/Logout/Logout";
import ForgotPassword from "../../components/ForgotPassword/ForgotPassword";
import ResetPassword from "../../components/ResetPassword/ResetPassword";
import NotFound from "../../components/NotFound/NotFound";
import { Link } from "react-router-dom";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
import qs from "querystring";
import { doValidateResetPasswordLink } from "../../services/ResetPassword";
import { useTranslation } from "react-i18next";
import {
  ApiStatusCodes,
} from "../../config/app-globals.enum";
import CustomLoader from "../../components/CustomLoader/CustomLoader";

export default function Auth(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [keyPressed, setKeyPressed] = useState(false);
  const [currentComponent, setCurrentComponent] = useState(
    props.history.location.pathname.substring(1)
  );
  const [queryToken, setQueryToken] = useState(null);
  const [queryEmail, setQueryEmail] = useState(null);

  useEffect(() => {
    const queryParams = qs.parse(props.history.location.search);
    const _token = queryParams["token"];
    const _email = queryParams["?email"];
    if (_token && _token.length) {
      setQueryToken(_token);
    }
    if (_email && _email.length) {
      setQueryEmail(_email);
    }
  }, [props.history]);

  useEffect(() => {
    let url = props.history.location.pathname.substring(1);
    url =
      url === "login" ||
      url === "forgotpassword" ||
      url === "resetpassword" ||
      url === "logout"
        ? url
        : "notfound";
    setCurrentComponent(url);
  }, [props]);

  function handleKeyDown(event) {
    const ENTER_KEY = 13;
    if (event.keyCode === ENTER_KEY) {
      setKeyPressed(true);
    }
  }

  function resetKeyPressed(isKeyPressed) {
    setKeyPressed(isKeyPressed);
  }

  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");

  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);

  useEffect(() => {
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      setAlertMessage(
        t("OLD_BROWSER_ALERT_ERROR")
      );
      setIsAlertOpen(true);
    }
  }, []);

  const [isResetLinkVerifyApiFailed, setIsResetLinkVerifyApiFailed] =
    React.useState(null);
  const [isResetLinkVerifyApi, setIsResetLinkVerifyApi] = React.useState(null);
  const [, setResetLinkVerifyStatusValue] =
    React.useState();
  const [
    resetLinkVerifyApiResponseMessage,
    setResetLinkVerifyApiResponseMessage,
  ] = React.useState();
  const [isResetLinkValid, setIsResetLinkValid] = React.useState(null);

  useEffect(() => {
    if (queryEmail && queryEmail.length && queryToken && queryToken.length) {
      validateResetPasswordLink(queryEmail, queryToken);
    }
    async function validateResetPasswordLink(email, sessionKey) {
      setIsResetLinkVerifyApi(true);
      setResetLinkVerifyStatusValue(null);
      setIsResetLinkValid(null);
      const data = await doValidateResetPasswordLink({
        email,
        sessionKey,
      });
      if (
        data &&
        data.status &&
        (data.status.code || data.status.code === 0)
      ) {
        if (
          data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201
        ) {
          setIsResetLinkValid(true);
          setIsResetLinkVerifyApiFailed(false);
        } else {
          setIsResetLinkValid(false);
          if (
            data.status.code === ApiStatusCodes.PASSWORD_CHANGE_SESSION_EXPIRED ||
            data.status.code ===
              ApiStatusCodes.PASSWORD_CHANGE_SESSION_INVALID_ERROR
          ) {
            setIsResetLinkVerifyApiFailed(false);
          } else {
            setIsResetLinkVerifyApiFailed(true);
          }
        }
        if (data.status.message) {
          setResetLinkVerifyApiResponseMessage(t(data.status.message));
        }
      } else {
        setIsResetLinkValid(false);
        setIsResetLinkVerifyApiFailed(true);
      }
      setIsResetLinkVerifyApi(false);
    }
  }, [queryToken, queryEmail]);

  return (
    <>
      <CustomContainer
        className={classes.root}
        maxWidth={false}
        onKeyDown={handleKeyDown}
      >
        <CustomPaper
          elevation={4}
          className={clsx(
            currentComponent === "notfound"
              ? classes.contentWrapperNotFound
              : classes.contentWrapper,
            currentComponent === "forgotpassword" ||
              currentComponent === "resetpassword"
              ? classes.contentWrapperForgotten
              : null
          )}
        >
          <span
            className={
              currentComponent === "notfound" ? null : classes.boxCircle
            }
          ></span>
          <CustomBox className={classes.logoWrapper}>
            {currentComponent === "login" && (
              <img src={Logo} style={{ height: "64px" }} alt="Logo" />
            )}
            {currentComponent === "notfound" && (
              <Link to="/dashboard">
                <img src={Logo} style={{ height: "64px" }} alt="Logo" />
              </Link>
            )}
            {(currentComponent === "forgotpassword" ||
              currentComponent === "resetpassword") && (
              <Link to="/login">
                <img src={Logo} style={{ height: "64px" }} alt="Logo" />
              </Link>
            )}
          </CustomBox>

          {currentComponent === "notfound" && <NotFound />}

          {currentComponent !== "notfound" && (
            <CustomGrid
              className={classes.formWrapper}
              item
              lg={6}
              md={7}
              sm={12}
              px={6}
            >
              {currentComponent === "login" && (
                <Login
                  handleKeyDown={keyPressed}
                  resetKeyDown={(isKeyPressed) => resetKeyPressed(isKeyPressed)}
                />
              )}
              {currentComponent === "logout" && <Logout />}
              {currentComponent === "forgotpassword" && (
                <ForgotPassword
                  handleKeyDown={keyPressed}
                  resetKeyDown={(isKeyPressed) => resetKeyPressed(isKeyPressed)}
                />
              )}
              {currentComponent === "resetpassword" &&
                (isResetLinkVerifyApi ? (
                  <CustomLoader>
                    Validating the reset password link, please wait
                  </CustomLoader>
                ) : (
                  <>
                    {isResetLinkVerifyApiFailed ? (
                      props.history.replace("/login")
                    ) : (
                      <>
                        {isResetLinkValid === true ? (
                          <ResetPassword
                            email={queryEmail}
                            token={queryToken}
                            handleKeyDown={keyPressed}
                            resetKeyDown={(isKeyPressed) =>
                              resetKeyPressed(isKeyPressed)
                            }
                          />
                        ) : isResetLinkValid === false ? (
                          <ForgotPassword
                            errorMessage={resetLinkVerifyApiResponseMessage}
                            handleKeyDown={keyPressed}
                            resetKeyDown={(isKeyPressed) =>
                              resetKeyPressed(isKeyPressed)
                            }
                          />
                        ) : null}
                      </>
                    )}
                  </>
                ))}
            </CustomGrid>
          )}
        </CustomPaper>
      </CustomContainer>
      <ErrorAlert
        code={200}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
    </>
  );
}
